// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"0b599c19","33":"7165964c","64":"b909308d","488":"9b16b28a","501":"746d1bb2","508":"29049016","659":"bbeb0c24","923":"6e38b601","970":"bc716f1e"}[chunkId] + ".chunk.js";
};